var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;clip-path:url(#SVGID_00000037672673458352647260000004862034199348534696_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000162336237578673546680000009772144681491658398_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137126195511082872950000007018485841476090269_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000137126195511082872950000007018485841476090269_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9c2.4,2.4,5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083778534118560320410000005284205501462368389_",
    x: 3.2,
    y: 3.6,
    width: 96.7,
    height: 96.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036967261562215355840000010440286394161280641_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083778534118560320410000005284205501462368389_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036967261562215355840000010440286394161280641_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.7,27.7v-8.1c0-4.3-1.7-8.4-4.7-11.4c-3-3-7.1-4.7-11.4-4.7H39.4C35.1,3.6,31,5.3,28,8.3 s-4.7,7.1-4.7,11.4v8.1c-5.4,0-10.5,2.1-14.2,5.9c-3.8,3.7-5.9,8.9-5.9,14.2V68c0,5.4,2.1,10.5,5.9,14.2c3.7,3.8,8.9,5.9,14.2,5.9 c0,3.2,1.3,6.3,3.5,8.5c2.3,2.3,5.3,3.5,8.5,3.5h32.2c3.2,0,6.3-1.3,8.5-3.5c2.3-2.3,3.5-5.3,3.5-8.5c5.4,0,10.5-2.1,14.2-5.9 c3.8-3.7,5.9-8.9,5.9-14.2V47.9c0-5.4-2.1-10.5-5.9-14.2C90.2,29.9,85.1,27.7,79.7,27.7z M31.4,19.7c0-2.1,0.8-4.2,2.4-5.7 c1.5-1.5,3.5-2.4,5.7-2.4h24.2c2.1,0,4.2,0.8,5.7,2.4c1.5,1.5,2.4,3.5,2.4,5.7v8.1H31.4V19.7z M71.6,88.2c0,1.1-0.4,2.1-1.2,2.9 c-0.8,0.7-1.8,1.2-2.9,1.2H35.4c-1.1,0-2.1-0.4-2.9-1.2c-0.7-0.8-1.2-1.8-1.2-2.9V72.1c0-1.1,0.4-2.1,1.2-2.9 c0.8-0.7,1.8-1.2,2.9-1.2h32.2c1.1,0,2.1,0.4,2.9,1.2c0.7,0.8,1.2,1.8,1.2,2.9V88.2z M91.8,68c0,3.2-1.3,6.3-3.5,8.5 c-2.3,2.3-5.3,3.5-8.5,3.5v-8.1c0-3.2-1.3-6.3-3.5-8.5c-2.3-2.3-5.3-3.5-8.5-3.5H35.4c-3.2,0-6.3,1.3-8.5,3.5 c-2.3,2.3-3.5,5.3-3.5,8.5v8.1c-3.2,0-6.3-1.3-8.5-3.5c-2.3-2.3-3.5-5.3-3.5-8.5V47.9c0-3.2,1.3-6.3,3.5-8.5 c2.3-2.3,5.3-3.5,8.5-3.5h56.4c3.2,0,6.3,1.3,8.5,3.5c2.3,2.3,3.5,5.3,3.5,8.5V68z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.7,43.9h-8.1c-1.1,0-2.1,0.4-2.9,1.2c-0.7,0.8-1.2,1.8-1.2,2.9c0,1.1,0.4,2.1,1.2,2.9 c0.8,0.7,1.8,1.2,2.9,1.2h8.1c1.1,0,2.1-0.4,2.9-1.2c0.7-0.8,1.2-1.8,1.2-2.9c0-1-0.4-2.1-1.2-2.9C77.8,44.3,76.8,43.9,75.7,43.9z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.44b63b302dcb7bcc6013112a7b4e131e.svg";
export { ForwardRef as ReactComponent };